import { render, staticRenderFns } from "./Contains.vue?vue&type=template&id=90822c38"
import script from "./Contains.vue?vue&type=script&lang=js"
export * from "./Contains.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports